export default {
  socialNetworks: 'सामाजिक नेटवर्क',
  sentEmails: 'ईमेल भेजे गए',
  peoplePerDay: 'प्रति दिन लोग',
  peoplePerMonth: 'प्रति माह लोग',
  statsPerApp: 'आवेदन के आंकड़े',
  search: 'खोज',
  name: 'नाम',
  people: 'लोग',
  person: 'व्यक्ति',
  sentMessages: 'संदेश भेजे गए',
  messagesParts: 'संदेश भागों',
  applicationsPerPage: 'प्रति पेज आवेदन',
  cellphoneRecords: 'सेलफोन रिकॉर्ड',
  totalRecords: 'कुल रिकॉर्ड',
  noName: 'बेनाम',
  noAppsToShow: 'दिखाने के लिए ऐप नहीं हैं',
  manualPayment: 'मैन्युअल भुगतान',
  manualCollection: 'मैनुअल संग्रह',
  noDataYet: 'फिलहाल डेटा नहीं है'
}
